import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import KDS from '../../Components/Admin/KDS/KDS';

export default function KDSPage() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <KDS />
                </div>
            </section>
        </div>
    );
}
